//dev
// export const API_SERVER_HOST = 'http://localhost:8080/keif';
//stage

// export const API_SERVER_HOST = 'https://server.keif.kr/keif';

//s3 이미지 경로
export const s3Url = 'https://broj.s3.ap-northeast-2.amazonaws.com/';

export const COOKIE_NAME = 'member';

// export const API_SERVER_HOST_COMMY = 'http://localhost:8081/commy';
// export const API_SERVER_HOST_COMMY = 'https://server.keif.kr/commy';

// config.js
// console.log('NODE_ENV:', process.env.NODE_ENV);

const isDev = process.env.NODE_ENV === 'development';

export const API_SERVER_HOST = isDev ? 'http://localhost:8080/keif' : 'https://server.keif.kr/keif';

export const API_SERVER_HOST_COMMY = isDev ? 'http://localhost:8081/commy' : 'https://server.keif.kr/commy';
